// Stages the backend writes while it works on a session. The session list
// refreshes itself while any row on the page is in one of them, so progress,
// completion and failures show up without a manual reload. "Waiting upload"
// and "Transcription pending" wait for the user, not the backend.
export const IN_PROGRESS_STAGES = new Set([
  "transcription running",
  "correcting with gpt",
  "correcting with gpt2",
  "fast: queued",
  "fast: downloading audio",
  "fast: converting audio",
  "fast: transcribing",
  "fast: persisting words",
  "fast: assembling",
]);

export const isInProgressStage = (stage) =>
  IN_PROGRESS_STAGES.has(String(stage || "").toLowerCase());

export const hasSessionsInProgress = (sessions) =>
  (sessions || []).some((session) => isInProgressStage(session && session.stage));

// The correction stores a transcript whose speakers GPT could not name with
// them unnamed, and leaves this notice (logic/transcriptions.py,
// SPEAKERS_NOT_ASSIGNED). The session list shows it next to the finished
// session, where any other leftover status text is hidden.
export const SPEAKERS_NOT_ASSIGNED_PREFIX = "Sprecher nicht automatisch zugeordnet";

export const isSpeakersNotice = (status) =>
  String(status || "").startsWith(SPEAKERS_NOT_ASSIGNED_PREFIX);
